<app-secondary-toolbar [self]="breadcrumbSelf">
</app-secondary-toolbar>

<div class="container-horizontal-padding container-vertical-padding animated fadeIn">

  <responsive-tabset class="fullscreen_tab" #insuranceTabs>

    <responsive-tab *ngIf="rightModel.clientDocumentRead.hasRight()"
                    heading="{{'INSURANCE_LIST'|translate}}">
      <app-colonnade-insurance-list
        #submittedList
        [dqlDialogHolder]="dqlDialogHolderSubmitted"
        [type]="ColonnadeInsuranceListType.INSURANCE">
      </app-colonnade-insurance-list>
    </responsive-tab>
    <responsive-tab *ngIf="rightModel.clientDocumentRead.hasRight()"
                    heading="{{'INSURANCE_OFFER_LIST'|translate}}">
      <app-colonnade-insurance-list
        #offerList
        [dqlDialogHolder]="dqlDialogHolderOffer"
        [type]="ColonnadeInsuranceListType.OFFER">
      </app-colonnade-insurance-list>
    </responsive-tab>
    <responsive-tab *ngIf="rightModel.colonnadeB2bRead.hasRight()"
                    heading="{{'COLONNADE_CLIENT_DOCUMENT_STAT_ENROLLER_REPORT'|translate}}">
      <app-colonnade-client-document-stat-enroller-report>
      </app-colonnade-client-document-stat-enroller-report>
    </responsive-tab>
    <responsive-tab *ngIf="rightModel.colonnadeB2bRead.hasRight()"
                    heading="{{'COLONNADE_CLIENT_DOCUMENT_STAT_PRODUCT_REPORT'|translate}}">
      <app-colonnade-client-document-stat-product-report>
      </app-colonnade-client-document-stat-product-report>
    </responsive-tab>
    <responsive-tab *ngIf="rightModel.colonnadeB2bRead.hasRight()"
                    heading="{{'COLONNADE_CLIENT_DOCUMENT_STAT_ENROLLER_SUMMARY'|translate}}">
      <app-colonnade-client-document-stat-enroller-summary>
      </app-colonnade-client-document-stat-enroller-summary>
    </responsive-tab>

  </responsive-tabset>


</div><!-- /container -->



<app-dql-dialog-container #dqlDialogHolderSubmitted></app-dql-dialog-container>
<app-dql-dialog-container #dqlDialogHolderOffer></app-dql-dialog-container>
